import React from 'react'
import { FormattedMessage } from 'react-intl'

import equalHousingOpportunityImage from './equal-housing-opportunity.svg'
import equalHousingLenderImage from './equal-housing-lender.svg'
import equalOpportunityLenderImage from './equal-opportunity-lender.png'

import { Text } from 'src/Components'

import styles from './HousingType.module.scss'
import { useSelector } from 'react-redux'
import { selectCorporateProfile } from 'src/store/selectors/customerProfile'

export interface HousingTypeProps {
  className?: string
}

const imagePropsForType = {
  equal_opportunity_lender: {
    src: equalOpportunityLenderImage,
    alt: 'Equal Opportunity Lender',
  },
  lender: {
    src: equalHousingLenderImage,
    alt: 'Equal Housing Lender',
  },
  opportunity: {
    src: equalHousingOpportunityImage,
    alt: 'Equal Housing Opportunity',
  },
}

const HousingType = ({ className }: HousingTypeProps) => {
  const corporateProfile = useSelector(selectCorporateProfile) || {}

  const { equalHousingType } = corporateProfile

  const imageProps = imagePropsForType[equalHousingType]

  if (!imageProps) {
    return null
  }

  return (
    <div className={className}>
      <img className={styles.image} src={imageProps.src} alt={imageProps.alt} />
      <div className={styles.typeCopy}>
        <Text>
          {equalHousingType === 'opportunity' && (
            <FormattedMessage
              id='Disclaimer.equalHousing.opportunity'
              defaultMessage='Equal Housing Opportunity.'
            />
          )}
          {equalHousingType === 'lender' && (
            <FormattedMessage
              id='Disclaimer.equalHousing.lender'
              defaultMessage='Equal Housing Lender.'
            />
          )}
          {equalHousingType === 'equal_opportunity_lender' && (
            <FormattedMessage
              id='Disclaimer.equalHousing.equal_opportunity_lender'
              defaultMessage='Equal Opportunity Lender.'
            />
          )}
        </Text>
      </div>
    </div>
  )
}

export default HousingType
